/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2021-07-10 16:44:32
 * @LastEditors: guorui.teng 704386484@qq.com
 * @LastEditTime: 2023-12-04 13:25:51
 */
import {
  BrowserRouter as Router,
  Route,
  Redirect,
} from 'react-router-dom';
import { lazy, Suspense } from 'react';

import Store from '../redux/store';

// const HomePage = lazy(() => import('../pages/homePage/homePage'));
import HomePage from '../pages/homePage/homePage';

const Assembly = lazy(() => import('@/components/Assembly/assembly'));
const PayService = lazy(() => import('@/components/PayService/payService'));
const Custom = lazy(() => import('../pages/custom/custom'));
const Case = lazy(() => import('../pages/case/case'));
const CaseMore = lazy(() => import('../pages/caseMore/caseMore'));

const CaseDetail = lazy(() => import('../components/CaseDetail/caseDetail'));
const PackOffer = lazy(() => import('../pages/packOffer/packOffer'));

function BasicRoute() {
  return (
    <Store>
      <Router basename="/kitchen-online">
        <Suspense fallback={null}>
          {/* 主页 */}
          <Route path="/home" component={HomePage} />
          {/* 优质厨房套餐 */}
          <Route path="/custom" component={Custom} />
          {/* 业主真实案例 */}
          <Route path="/case" component={Case} />
          {/* 业主真实案例更多 */}
          <Route path="/caseMore" component={CaseMore} />
          {/* 配送服务 */}
          <Route path="/home/assembly" component={Assembly} />
          {/* 付费组装服务 */}
          <Route path="/home/payService" component={PayService} />
          {/* 真实案例详情 */}
          <Route path="/caseDetail" component={CaseDetail} />
          {/* mcc详情 */}
          <Route path="/home/packOffer" component={PackOffer} />
          <Route path="/home/designList/:code" component={PackOffer} />
          <Route
            path="/index.html"
            exact
            render={() => <Redirect to="/home" />}
          />
        </Suspense>
      </Router>
    </Store>
  );
}

export default BasicRoute;
